var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm.isAdminNotConsultant(_vm.loggedUserData) ? _c("AdminProducersSubMenusLinks", {
    attrs: {
      loggedUserData: _vm.loggedUserData
    },
    on: {
      tabChanged: _vm.tabChanged
    }
  }) : _vm._e(), _c("ProducerList", {
    attrs: {
      loggedUserData: _vm.loggedUserData,
      type: _vm.selectedTab
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };